import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

interface CustomModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  width?: string;
  noneTitle?: boolean
}

export const CustomModal = ({ isOpen, onClose, title, children, width = "max-w-lg", noneTitle }: CustomModalProps) => {
  const modalRef = useRef<HTMLDivElement | null>(null);
  const firstFocusableRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (isOpen && firstFocusableRef.current) {
      firstFocusableRef.current.focus();
    }
  }, [isOpen]);


  const handleBackdropClick = (event: React.MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return createPortal(
    <div
      onClick={handleBackdropClick}
      className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div
        ref={modalRef}
        className={`relative ${width ? width : 'w-full'} rounded-lg bg-white p-6 shadow-xl`}
        role="dialog"
        aria-modal="true"
      >
        <div className={`w-full flex items-center mb-4 ${title ? ' justify-between' : 'justify-end'} `}>
          {title && !noneTitle && <h2 className=" w-full text-xl font-semibold text-center text-primary">{title}</h2>}
          <button
            ref={firstFocusableRef}
            onClick={onClose}
            className={`text-gray-500 hover:text-gray-700 focus:outline-none ${noneTitle && 'hidden'}`}
            aria-label="Fechar modal"
          >
            X
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
};